// Common
import { NonScCommon } from './nonsc.common'

import {
  NonScHomeCommon as HomeCommon, HomeInput
} from './nonsc-home.common'

import {
  NonScUserCommon as UserCommon, UserInput
} from './nonsc-user.common'

// Utils
import {
  ValidateUtility as Validate
} from '../utils/validate'

/**
 * Import item properties
 * @typedef ImportRecord
 * @type {Object}
 * @property {Number} id - Record ID
 * @typedef {HomeInput & UserInput & ImportRecord} ImportItem
 */

/**
 * Import item valid state
 * @typedef ImportItemValid
 * @type {Object}
 * @property {Boolean} all                      - Valid all
 * @property {Boolean | String} name            - Valid name
 * @property {Boolean | String} mobileNoValid   - Valid mobile number
 * @property {Boolean | String} mobileNoUnique  - Valid mobile number
 * @property {Boolean | String} emailValid      - Valid email
 * @property {Boolean | String} emailUnique     - Valid email
 * @property {Boolean | String} address         - Valid address
 * @property {Boolean | String} structure       - Valid construction type
 * @property {Boolean | String} area            - Valid usable area
 * @property {Boolean | String} role            - Valid role
 */

export class NonScImportCommon {

  /** @type {ImportItemValid} */
  static valid = {
    all             : false,
    name            : false,
    mobileNoValid   : false,
    mobileNoUnique  : false,
    emailValid      : true,
    emailUnique     : true,
    address         : false,
    structure       : false,
    area            : false,
    role            : false,
    transferDate    : false,
    unique          : false,
  }

  /** @type {ImportItemValid} */
  static error = {
    name            : 'ชื่อนามสกุลไม่ถูกต้อง',
    mobileNoValid   : 'เบอร์มือถือไม่ถูกต้อง',
    mobileNoUnique  : 'เบอร์มือถือซ้ำ',
    emailValid      : 'อีเมล์ไม่ถูกต้อง',
    emailUnique     : 'อีเมล์ซ้ำ',
    address         : 'ที่อยู่ไม่ถูกต้อง',
    structure       : 'ประเภทสิ่งก่อสร้างไม่ถูกต้อง',
    area            : 'พื้นที่ใช้สอยไม่ถูกต้อง',
    role            : 'สถานะไม่ถูกต้อง',
    transferDate    : 'วันที่โอนไม่ถูกต้อง',
    unique          : 'ข้อมูลซ้ำ',
  }

  /** @type {ImportItem} */
  static item = Object.assign(
    { id: null }, UserCommon.input, HomeCommon.input
  )

  /**
   * Import input validator
   * @param {ImportItem} item - Import Data
   * @returns {ImportItemValid} Import Data
   */
  static validator(item) {
  
    // Valid State
    /** @type {ImportItemValid} */
    const valid = {
      all             : false,
      name            : false,
      mobileNoUnique  : false,
      mobileNoValid   : false,
      emailUnique     : true,
      emailValid      : true,
      address         : false,
      structure       : false,
      role            : false,
      transferDate    : false,
      unique          : false
    }

    // Validate Item
    if (!item) return valid

    // Item Props
    const {
      firstName,
      lastName,
      role,
      addressNo,
      structure,
      mobileNo,
      transferDate,
    } = item

    // Validate Mobile No
    valid.mobileNoValid = (
      Validate.isMobileNo(mobileNo)
    )

    // Validate Name
    valid.name = (
      !!firstName && !!lastName
    )

    // Validate Role
    valid.role = Validate.isRole(role)

    // Validate Address
    valid.address = (
      Validate.isLocation(item) && Validate.isAddrNo(addressNo)
    )

    // Validate Construct
    const building = NonScCommon.construct.find(
      ({ name }) => name == structure
    )

    // Validate Structure
    if (building) {
      valid.structure = (
        Validate.isStructure(building.value)
      )
    }

    // Validate Transfer Date
    valid.transferDate = (
      Validate.isDate(transferDate)
    )

    return valid
  }

  /**
   * Map & Format Import Data
   * @param {ImportItem} item  - Import Data
   * @param {Number} index          - Import Index
   * @returns {ImportItem} Import Data
   */
  static map(item, index) {

    // Validate Item
    if (!item) return item

    // Item Props
    const {
      firstName,
      lastName,
      mobileNo,
      zipCode,
      transferDate
    } = item

    // Set ID
    item.id = index + 1
    
    // Set Mobile Number
    if (mobileNo) {
      item.mobileNo = mobileNo.replace(/\D/g, '')
    }

    // Get Role
    const role = (
      NonScCommon.role.find(e => e.value == item.role)
    )
    
    // Set Role Name
    item.roleName = (
      role ? role.name : null
    )

    // Format Name 
    item.firstName = firstName
    item.lastName = lastName

    // Set Name
    if (!!firstName && !!lastName) {
      item.name = [firstName, lastName].join(' ')
    }

    // Set Address
    item.zipCode = `${zipCode}`

    // Transfer Date Pattern
    const isDate = new RegExp(
      /\d{1,2}\/\d{1,2}\/\d{4}/g
    )
    
    // Validate Transfer Date
    if (isDate.test(transferDate)) {

      // Date Props
      const [d, m, y] = transferDate.split('/')

      // Set Transfer Date
      item.transferDate = `${y}-${m}-${d}`
    }

    return item
  }
}



// WEBPACK FOOTER //
// ./src/features/nonsc/common/nonsc-home-import.common.js